import { Injectable } from '@angular/core';
import { getSearchParamFromUrl } from '@app/shared/utils';

@Injectable({
  providedIn: 'root',
})
export class InitiatorService {
  readonly clientId: string | null = getSearchParamFromUrl('client');
  readonly redirectUri: string | null = getSearchParamFromUrl('redirect_uri');
}
